(() => {
  const form = document.querySelector('#ContactForm');
  if (!form || form.dataset.validationInitialized === 'true') return;

  form.dataset.validationInitialized = 'true';

  const requiredFields = [
    form.querySelector('#ContactForm-name'),
    form.querySelector('#ContactForm-email'),
    form.querySelector('#ContactForm-body'),
  ].filter(Boolean);
  const captchaError = form.querySelector('#ContactForm-captcha-error');
  let submissionFeedbackTimer;

  const showFieldError = (field) => {
    const error = form.querySelector(`#${field.id}-error`);
    if (!error) return;

    error.textContent = field.validity.valueMissing ? field.dataset.requiredMessage : field.validationMessage;
    error.hidden = false;
    field.setAttribute('aria-invalid', 'true');
  };

  const clearFieldError = (field) => {
    const error = form.querySelector(`#${field.id}-error`);
    if (!error) return;

    error.textContent = '';
    error.hidden = true;
    field.setAttribute('aria-invalid', 'false');
  };

  requiredFields.forEach((field) => {
    field.addEventListener('invalid', () => showFieldError(field));
    field.addEventListener('input', () => {
      if (field.validity.valid) {
        clearFieldError(field);
      } else if (field.getAttribute('aria-invalid') === 'true') {
        showFieldError(field);
      }
    });
  });

  form.addEventListener('submit', () => {
    if (!captchaError) return;

    captchaError.hidden = true;
    captchaError.textContent = '';
    window.clearTimeout(submissionFeedbackTimer);
    submissionFeedbackTimer = window.setTimeout(() => {
      if (!document.contains(form)) return;

      captchaError.textContent = captchaError.dataset.defaultMessage;
      captchaError.hidden = false;
    }, 15000);
  });

  window.addEventListener('pagehide', () => window.clearTimeout(submissionFeedbackTimer), { once: true });
})();
